// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../../../Config.bs.js";
import * as LoadAssistInfoRepo from "./LoadAssistInfoRepo.bs.js";
import * as DummyLoadAssistInfoRepo from "./DummyLoadAssistInfoRepo.bs.js";

function getLoadAssistInfoRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyLoadAssistInfoRepo.LoadAssistInfoRepo;
  } else {
    return LoadAssistInfoRepo.LoadAssistInfoRepo;
  }
}

export {
  getLoadAssistInfoRepo ,
  
}
/* Config Not a pure module */
